import type { GoogleSignupToolkit } from './google-signup-consent-config';

// A login that starts before a web deploy returns from Auth0 into the new
// bundle and must still find the verifier the old bundle wrote, so the
// stored keys never change
type StoredLogin = {
  code_verifier?: string;
  login_attempt?: string;
  google_signup_toolkits?: GoogleSignupToolkit[];
};

export function storeBeforeRedirect(
  state: string,
  login: {
    codeVerifier: string;
    loginAttempt?: string;
    googleSignupToolkits?: GoogleSignupToolkit[];
  }
): void {
  sessionStorage.setItem(
    state,
    JSON.stringify({
      code_verifier: login.codeVerifier,
      login_attempt: login.loginAttempt,
      google_signup_toolkits: login.googleSignupToolkits,
    })
  );
}

export function readAfterRedirect(state: string): {
  codeVerifier: string | null;
  loginAttempt: string | null;
  googleSignupToolkits: GoogleSignupToolkit[];
} {
  const stored = sessionStorage.getItem(state);
  if (!stored)
    return { codeVerifier: null, loginAttempt: null, googleSignupToolkits: [] };

  try {
    const parsed = JSON.parse(stored) as StoredLogin;
    return {
      codeVerifier: parsed.code_verifier ?? null,
      loginAttempt: parsed.login_attempt ?? null,
      googleSignupToolkits: parsed.google_signup_toolkits ?? [],
    };
  } catch {
    return { codeVerifier: null, loginAttempt: null, googleSignupToolkits: [] };
  }
}
